<template>
  <div>
    <div style="height: 120px"></div>
    <div class="box_foot">
      <div class="box_foot_title" style="font-size: 16px;">
        <div style="margin-right: 40px">客服邮箱：{{configdata.maile}}</div>
        <div>联系电话：{{ configdata.servicephone }} 工作日：9:00-18:00</div>
      </div>
      <div class="box_foot_line"></div>
      <div class="box_foot_content">
        <div class="box_foot_content_banquan">Copyright © 2010-2023 华道艾腾 ALL Rights Reserved 版权所有</div>
        <div class="box_foot_content_beian" style="margin-left: 60px;">
          <a target="_blank" style="font-size: 14px;color: #fff;" :href="'https://beian.miit.gov.cn/#/Integrated/index'"> 工信部备案号：{{configdata.sitebeian}} </a>
          <img class="box_foot_content_beian_police" :src="police">
          <a target="_blank" style="font-size: 14px;color: #fff;"  :href="'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode='+ configdata.policebeiant"> 公安备案号： {{configdata.policebeiansn}} </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import policeimg from '@/assets/images/police.png'
import police from "@/assets/police.png";


export default {
  name: 'indexfooter',
  data() {
    return {
      police:police,
      policeimg: policeimg,
      configdata:{}
    }
  },
  created() {
    var configdata =  JSON.parse(localStorage.getItem('configdata'))
    this.configdata = configdata
  },
  methods:{
    gokefu(){
      window.open(this.configdata.serviceurl,'_blank')
    },
  }

}
</script>
<style lang="scss" scoped>
.box_foot{
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 125px;
  background: #333;
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 9;
}

.box_foot_title{
  display: flex;
  justify-content: center;
  height: 62px;
  line-height: 62px;
  color: #fff;
  font-size:18px;
}

.box_foot_line{
  display: block;
  width: 1000px;
  height: 1px;
  background: #E9E9E9;
  margin: 0 auto;
}

.box_foot_content{
  display: flex;
  justify-content: center;
  height: 62px;
  line-height: 62px;
  color: #fff;
}

.box_foot_content_beian{
  display: flex;
  flex-direction: row;
}

.box_foot_content_beian_police{
  display: block;
  width: 20px;
  height: 20px;
  margin: auto 5px;
}


</style>

